import { render, staticRenderFns } from "./top-right.vue?vue&type=template&id=0b0ba1fe&scoped=true&"
import script from "./top-right.vue?vue&type=script&lang=js&"
export * from "./top-right.vue?vue&type=script&lang=js&"
import style0 from "./top-right.vue?vue&type=style&index=0&id=0b0ba1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ba1fe",
  null
  
)

export default component.exports